import React, { useState, useEffect, useRef } from "react";
import axiosConfig from "../../Service/AxiosConfig";
import "./Profile.css";
import loader from "../../Animations/Sandy Loading.gif";
import { useDispatch, useSelector } from "react-redux";
import BookingList from "./BookingList";
import { PopupModal } from "../../PopupModal/PopupModal";
import AddressGrid from "./AddressGrid";
import QualificationRole from "./QualificationRole";
import { useAuth } from "../../Context/AuthContext";
import BasicInfo from "./BasicInfo";
import WorkPreferences from "./WorkPreferences";
import Verification from "./Verification";
import Documents from "./Documents";
import { setProfile } from "../../redux/ProfileSlice";
const Profile = () => {
  const tempData = useSelector((state) => state.bookingForm.tempData);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [booking, setBooking] = useState(null);
  const [form, setForm] = useState(null);
  const { user } = useAuth();
  const userId = user?.id;
  const [popupType, setpopupType] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const fetchBooking = async () => {
    try {
      setLoading(true);
      const response = await axiosConfig.get(
        `/provider-data/providers/?user=${userId}`,
      );
      const data = response?.data?.results?.[0];
      setBooking(response?.data?.results);
      dispatch(
        setProfile({
          name: data?.user?.name || "",
          mobileno: data?.user?.mobileno || "",
          profile: data?.user?.profile || null,
        }),
      );
      setForm({
        id: data?.id || "",
        gender: data?.gender || "",
        date_of_birth: data?.date_of_birth || "",
        years_of_experience: data?.years_of_experience || "",
        availability: data?.availability || "",
        profile_completed: data?.profile_completed || false,
        created_at: data?.created_at || "",
        updated_at: data?.updated_at || "",
        user_id: data?.user?.id || "",
        name: data?.user?.name || "",
        profile: data?.user?.profile || null,
        mobileno: data?.user?.mobileno || "",
        email: data?.user?.email || "",
        services: data?.services?.[0]?.id || [],
        languages: data?.languages?.map((l) => l.id) || [],
        education_level: data?.education_level?.map((l) => l.id) || [],
        preferred_zones: data?.preferred_zones?.map((z) => z.id) || [],
        available_shifts: data?.available_shifts?.map((s) => s.id) || [],
        days_available: data?.days_available?.map((d) => d.id) || [],
        emergency_calls: data?.emergency_calls || false,
        aadhaar_number: data?.aadhaar_number || "",
        adhaar_file: data?.adhaar_file || null,
        pan_number: data?.pan_number || "",
        pan_file: data?.pan_file || null,
        documents: data?.documents || [],
        current_address: data?.current_address?.address || "",
        current_lat: data?.current_address?.latitude || null,
        current_lng: data?.current_address?.longitude || null,
        current_address_id: data?.current_address?.id || null,
        permanent_address: data?.permanent_address?.address || "",
        permanent_lat: data?.permanent_address?.latitude || null,
        permanent_lng: data?.permanent_address?.longitude || null,
        permanent_address_id: data?.permanent_address?.id || null,
        aadhaar_verified: data?.aadhaar_verified || false,
        pan_verified: data?.pan_verified || false,
      });
    } catch (error) {
      console.error("Provider API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!userId) return;
    fetchBooking();
  }, [userId]);

  if (loading && !form) {
    return (
      <div className="loader-wrapper">
        <img src={loader} alt="Loading..." />
      </div>
    );
  }
  return (
    <>
      <div className="patient-dashboard-child">
        <div className="profile">
          <h3>Profile </h3>
        </div>
        {form && (
          <>
            {booking && <BookingList booking={booking} />}
            <BasicInfo
              form={form}
              setForm={setForm}
              fetchBooking={fetchBooking}
            />
            <AddressGrid
              form={form}
              setForm={setForm}
              fetchBooking={fetchBooking}
            />
            <QualificationRole
              form={form}
              setForm={setForm}
              fetchBooking={fetchBooking}
            />
            <Verification
              form={form}
              setForm={setForm}
              fetchBooking={fetchBooking}
            />
            <WorkPreferences
              form={form}
              setForm={setForm}
              fetchBooking={fetchBooking}
            />
            <Documents
              form={form}
              setForm={setForm}
              fetchBooking={fetchBooking}
            />
          </>
        )}
      </div>
      {popupType && (
        <PopupModal
          popupType={popupType}
          setpopupType={setpopupType}
          Message={message}
          error={error}
          setMessage={setMessage}
        />
      )}
    </>
  );
};

export default Profile;
